import $ from "jquery";

export default function alertDialog({ title = '', content = {}, type = '' }) {
    const dialog = $(`
    <div class="alert_dialog ${type}">
        <div class="dialog_backdrop"></div>
        <div class="dialog_container">
            <div class="dialog">
                <a href="#" class="icon close orange"></a>
                <div class="dialog_body">
                    ${title != '' ? '<h3 class="dialog_header">' + title + '</h3>' : ''}
                    <div class="dialog_content"></div>
                </div>
            </div>
        </div>
    </div>
    `);
    dialog.find('.dialog_content').append(content);
    $('body').append(dialog);
    dialog.show();
    dialog.find('.close').on('click', function (e) {
        e.preventDefault();
        dialog.remove();
    });

}